/** Formatos pt-BR que o editor usa (número, data e hora). */

/** Número pt-BR: milhar com ponto, decimais fixos. */
export function formatNumberBR(value: number, decimals: number = 0): string {
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value);
}

/** Lê um número digitado em pt-BR: "3.333,50" → 3333.5. */
export function parseBRNumber(s: string | number): number {
  if (typeof s === 'number') return s;
  const clean = String(s).trim().replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '');
  const n = parseFloat(clean);
  return Number.isNaN(n) ? 0 : n;
}

const dois = (n: number) => String(n).padStart(2, '0');

function lerData(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** dd/MM/aaaa (hora local). */
export function formatDate(iso: string | null | undefined): string {
  const d = lerData(iso);
  if (!d) return iso || '-';
  return `${dois(d.getDate())}/${dois(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** "dd/MM/aaaa às HH:mm" (hora local). */
export function formatDateTime(iso: string | null | undefined): string {
  const d = lerData(iso);
  if (!d) return iso || '-';
  return `${formatDate(iso)} às ${dois(d.getHours())}:${dois(d.getMinutes())}`;
}
